import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { WhatsInsideSection } from '../components/WhatsInsideSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { BonusSection } from '../components/BonusSection';
import { WhoIsThisForSection } from '../components/WhoIsThisForSection';
import { PriceSection } from '../components/PriceSection';
import { FinalCtaSection } from '../components/FinalCtaSection';
import { SocialProofPopup } from '../components/SocialProofPopup';
export function LandingPage() {
  return <div className="min-h-screen bg-[#0a0a0a] text-white font-sans selection:bg-amber-500/30 selection:text-amber-200" data-id="element-198">
      <HeroSection data-id="element-199" />
      <ProblemSection data-id="element-200" />
      <SolutionSection data-id="element-201" />
      <WhatsInsideSection data-id="element-202" />
      <TestimonialsSection data-id="element-203" />
      <BonusSection data-id="element-204" />
      <WhoIsThisForSection data-id="element-205" />
      <PriceSection data-id="element-206" />
      <FinalCtaSection data-id="element-207" />

      {/* Footer Simple */}
      <footer className="py-8 bg-black text-center text-gray-600 text-sm border-t border-gray-900" data-id="element-208">
        <p data-id="element-209">
          © {new Date().getFullYear()} Guía Completa de ADC. Todos los derechos
          reservados.
        </p>
        <p className="mt-2" data-id="element-210">Este sitio no está afiliado con Riot Games.</p>
      </footer>

      <SocialProofPopup data-id="element-211" />
    </div>;
}